(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !window.DesignMode) return;
  try {
    
// self executing function here
(function() {
var countDownContainer = document.querySelector('.mocy-c--wrapper');
  if(countDownContainer){
var text = document.querySelector('.mocy-c--wrapper').dataset.countdownText;
var time = document.querySelector('.mocy-c--wrapper').dataset.countdownTime;
var textAfter = document.querySelector('.mocy-c--wrapper').dataset.countdownTextAfter;
  function calculateTime(exDate, text, textAfter){
    var countDownDate = new Date(exDate).getTime();
    var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      document.getElementById("mocy-c--content").innerHTML = text + " " + hours + "h "
        + minutes + "m " + seconds + "s ";
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("mocy-c--content").innerHTML = textAfter;
      }
    }, 1000);
  }
  calculateTime(time, text, textAfter);    
}
})();

  } catch(e) { console.error(e); }
})();
})();
